import React from 'react'

export default function TableCellNA() {
  return <div className='text-center opacity-40'>N/A</div>
}
